import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function ProfileTermsAndConditions() {
  return (
    <div>
      <h1 className="text-white font-bold text-4xl">Terms and Conditions</h1>
      <p className="text-gray-100">
        Below are the terms and conditions for using our service. By using our service, you agree to these terms.
      </p>

      <div className="flex flex-col gap-4 mt-4">
        <a
          target="_blank"
          href="https://www.devmind.ro/confidentialitate"
          rel="noreferrer"
          className="text-blue-400 hover:underline inline-flex items-center w-fit"
        >
          Confidentiality Policy <OpenInNewIcon className="ml-1" fontSize="small" />
        </a>
        <a
          target="_blank"
          href="https://www.devmind.ro/termeni-si-conditii"
          rel="noreferrer"
          className="text-blue-400 hover:underline inline-flex items-center w-fit"
        >
          Terms and Conditions <OpenInNewIcon className="ml-1" fontSize="small" />
        </a>
        <a
          target="_blank"
          href="https://www.devmind.ro/politica-cookie"
          rel="noreferrer"
          className="text-blue-400 hover:underline inline-flex items-center w-fit"
        >
          Cookie Policy <OpenInNewIcon className="ml-1" fontSize="small" />
        </a>
      </div>
    </div>
  );
}

export default ProfileTermsAndConditions;
